import React, { useState } from "react";
import { Star, ExternalLink, MessageSquarePlus, ChevronDown } from "lucide-react";

// URLs de Google
const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/SALUD+Y+VISI%C3%93N./@40.433078,-3.6553856,17z/data=!4m8!3m7!1s0xd422f49baf8781d:0x9a37d19528626bc5!8m2!3d40.433078!4d-3.6553856!9m1!1b1";

const WRITE_REVIEW_URL =
  "https://search.google.com/local/writereview?placeid=ChIJHYeP-ZsvQg0RxWtiKJXRN5o";

// Reseñas reales extraídas de la ficha Natural Optics + testimonios de Salud Visión (con fuente verificable)
const REVIEWS = [
  {
    name: "Natalia",
    date: "16 dic 2024",
    rating: 5,
    text: "Para mí es un CENTRO DE REFERENCIA para la valoración y tratamiento visual. Mis dos hijas han sido valoradas al detalle por Laura. En una de ellas, su valoración desveló que los problemas de atención en el colegio eran causados por un tema visual. Tras 6 meses de tratamiento los cambios eran más que visibles.",
  },
  {
    name: "Cristina",
    date: "6 oct 2024",
    rating: 5,
    text: "Si he aprobado mi oposición ha sido gracias a ellos. Pensé que había perdido calidad de ojos la cual no sería recuperable y gracias a su terapia mis ojos han vuelto a recuperar. Llevé también a mi hijo y ha subido el rendimiento académico. ¡Qué gran descubrimiento!",
  },
  {
    name: "Clara",
    date: "31 mar 2025",
    rating: 5,
    text: "Fui porque mi hijo no veía bien y tenía dolores de cabeza, y ahora es otro niño. Aproveché para hacerme una revisión y me cambiaron la vida a mí también. He ampliado mi campo de visión y puedo concentrarme mucho más tiempo. Todo el equipo es maravilloso. Lo recomiendo 100%.",
  },
  {
    name: "María",
    date: "13 jun 2024",
    rating: 5,
    text: "Ana y Lorena son dos profesionales increíbles. Empáticas, perfeccionistas y con un trato al paciente espectacular. Confío al mil por cien en ellas para cuidar mis ojos y los de mis peques. ¡Marcáis la diferencia!",
  },
  {
    name: "Nagore",
    date: "28 may 2025",
    rating: 5,
    text: "Un equipo de profesionales increíble. El trato al paciente es único: el tiempo no importa, sólo importa que el niño se sienta a gusto. Mi hija, además de ir feliz a su terapia visual, ya ha empezado a notar cambios en su día a día. ¡Es maravilloso ver cómo mejora!",
  },
  {
    name: "Belén",
    date: "6 mar 2025",
    rating: 5,
    text: "Muy profesionales y respetuosos. Un trato exquisito e individualizado donde el cliente es la prioridad. Atentos y continuamente en formación. Han ido mis tres hijos y yo misma. Nos han dado respuestas que en otros lugares no nos dieron.",
  },
  {
    name: "Guadalupe",
    date: "25 dic 2024",
    rating: 5,
    text: "Les conocí hace 8 años porque traía a mi hija a terapia visual de pequeña, le ayudaron muchísimo para superar un ojo vago. Desde entonces nos hacemos las gafas aquí a pesar de que nos pilla lejos de casa. Es un lujo, sobre todo Ana.",
  },
  {
    name: "Carmen",
    date: "2 mar 2026",
    rating: 5,
    text: "Ha sido una experiencia maravillosa, tanto por Laura, Natalia y Mari Luz, que son encantadoras, como por los avances que ha conseguido mi hija. Lo recomiendo a todos los padres que necesiten este tipo de servicio.",
  },
  {
    name: "Mara",
    date: "25 mar 2025",
    rating: 5,
    text: "Nuestro hijo ha estado en el centro haciendo terapias visuales. La mejora y la evolución han sido muy positivas. Estamos muy contentos con el personal del centro y con todo en general. Lo recomiendo cien por cien.",
  },
  {
    name: "Claudia",
    date: "28 nov 2024",
    rating: 5,
    text: "¡Increíbles profesionales! En otra óptica me quisieron poner unos lentes que podían dañarme la vista, y ellos enseguida supieron ver el problema real. La rapidez y sencillez de las nuevas lentes fue fantástico. ¡El sitio no puede ser mejor!",
  },
  {
    name: "Mar",
    date: "4 abr 2024",
    rating: 5,
    text: "Fui de casualidad por recomendación y acabé con mis primeras gafas graduadas. María José y sus compañeras son muy profesionales. Lo mejor fue el tiempo que se tomaron en atendernos. Sin prisas, muy atentas, respondiendo a todas mis dudas y encima majísimas. ¡Estoy encantada!",
  },
  {
    name: "Rosa",
    date: "18 ene 2026",
    rating: 5,
    text: "Excelentes profesionales. Asesoramiento y trato al cliente impecables. Monturas muy bonitas. Precios ajustados.",
  },
  {
    name: "Katherine",
    date: "27 feb 2025",
    rating: 5,
    text: "Son las mejores sin duda alguna. Descubrí que tenía astigmatismo por estrés gracias a ellas, y no miopía como pensaba. Son todo terreno. Menciones a Ana y Lorena que me aguantan tanto.",
  },
  {
    name: "Iván",
    date: "19 jul 2025",
    rating: 5,
    text: "Óptica recomendable. Muy buen trato, revisión gratis al año, te ayudan con la reparación de las gafas. Hace poco se me partieron y se ofrecieron a pegármelas en vez de comprar unas nuevas. Un detalle muy bonito.",
  },
  {
    name: "Josefina",
    date: "12 mar 2024",
    rating: 5,
    text: "Hace años que soy cliente y confío en esta óptica. Ana, que es quien me trata a mí, es una excelente profesional y encantadora en el trato. Totalmente recomendables.",
  },
  {
    name: "Nacho",
    date: "9 ene 2026",
    rating: 5,
    text: "La atención y profesionalidad de las trabajadoras de Salud y Visión es excelente. Su trato cercano y amable te hace sentirte perfectamente atendido. Sin duda, muy recomendable.",
  },
];

const BATCH_SIZE = 4;

const Stars = ({ count = 5 }) => (
  <div className="flex gap-0.5" aria-label={`${count} de 5 estrellas`}>
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        size={15}
        fill={i < count ? "#f5b93a" : "transparent"}
        stroke={i < count ? "#f5b93a" : "#d0cdc2"}
        strokeWidth={1.5}
      />
    ))}
  </div>
);

const getInitials = (name) => {
  const parts = name.trim().split(" ");
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : name.slice(0, 2).toUpperCase();
};

const GoogleReviews = () => {
  const [visible, setVisible] = useState(BATCH_SIZE);
  const hasMore = visible < REVIEWS.length;
  const remaining = REVIEWS.length - visible;
  const showMore = () => setVisible((v) => Math.min(v + BATCH_SIZE, REVIEWS.length));

  return (
    <section className="py-24 px-6" data-testid="google-reviews-section">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full font-sans-body text-xs font-semibold mb-5" style={{ background: "var(--sage-50)", color: "var(--sage-700)", border: "1px solid var(--sage-200)" }}>
            <Stars count={5} />
            <span className="ml-1">Más de {REVIEWS.length} reseñas de pacientes reales</span>
          </div>
          <h2 className="section-title">
            Lo que dicen <span className="handwritten">nuestros pacientes</span>
          </h2>
          <p className="font-sans-body text-[color:var(--ink-soft)] mt-5">
            Más de 20 años cuidando miradas en Madrid. Estas son algunas voces reales de pacientes y familias que han pasado por nuestro centro.
          </p>
        </div>

        {/* Grid de reseñas */}
        <div className="grid md:grid-cols-2 gap-5 mt-14" data-testid="reviews-grid">
          {REVIEWS.slice(0, visible).map((r, i) => (
            <article
              key={i}
              className="soft-card flex flex-col"
              style={{ padding: "1.75rem", animation: i >= visible - BATCH_SIZE && i > 0 ? "fadeUp 0.5s ease-out" : "none" }}
              data-testid={`review-${i}`}
            >
              {/* Top row: avatar + nombre + fecha */}
              <div className="flex items-start gap-3">
                <div
                  className="h-11 w-11 rounded-full flex items-center justify-center font-sans-body font-semibold shrink-0 text-sm"
                  style={{ background: "var(--sage-500)", color: "var(--cream)" }}
                  aria-hidden="true"
                >
                  {getInitials(r.name)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-sans-body font-semibold text-[color:var(--ink)] truncate">{r.name}</div>
                  <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                    <Stars count={r.rating} />
                    <span className="font-sans-body text-xs text-[color:var(--ink-soft)]">· {r.date}</span>
                  </div>
                </div>
                {/* Logo G de Google */}
                <div
                  className="h-7 w-7 rounded-full flex items-center justify-center font-bold text-sm shrink-0"
                  style={{
                    background: "#fff",
                    border: "1px solid #e4e4e4",
                    color: "#4285F4",
                    fontFamily: "Arial, sans-serif",
                  }}
                  aria-label="Reseña de Google"
                  title="Reseña en Google"
                >
                  G
                </div>
              </div>

              {/* Texto */}
              <p className="font-sans-body text-sm text-[color:var(--ink-soft)] mt-4 leading-relaxed flex-1">
                "{r.text}"
              </p>
            </article>
          ))}
        </div>

        {/* Botón "Ver más" */}
        {hasMore && (
          <div className="mt-10 text-center">
            <button
              onClick={showMore}
              className="btn-ghost"
              data-testid="reviews-show-more"
            >
              Ver más reseñas ({remaining} restantes) <ChevronDown size={16} />
            </button>
          </div>
        )}

        {/* CTAs finales */}
        <div className="mt-12 flex flex-wrap justify-center gap-3" data-testid="reviews-ctas">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            data-testid="reviews-see-all"
          >
            Ver todas en Google <ExternalLink size={16} />
          </a>
          <a
            href={WRITE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost"
            data-testid="reviews-write"
          >
            Déjanos tu reseña <MessageSquarePlus size={16} />
          </a>
        </div>

        <p className="text-center font-sans-body text-xs text-[color:var(--ink-soft)] mt-6 opacity-75">
          Las reseñas se gestionan en Google · tu opinión nos ayuda a mejorar cada día
        </p>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
};

export default GoogleReviews;
